import { FC } from 'react';

import css from './PageTitle.module.scss';

export const PageTitle: FC = ({ children }) => {
  return <h1 className={css.pageTitle}>{children}</h1>;
};
